import _ from "lodash";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { editDocumentMetadata } from "../../../services/document";
import * as actions from "../documentActions";
import { setDocumentStatus, setDate } from "../utils";
import { openSnackbar } from "../../_shared/snack-bar/snackbarActions";
import { errorOpenModal } from "../../_shared/modal/errorModalActions";
import { fetch as fetchProject } from "../../project/projectActions";

export const DOC_STATUS_DISPLAY = {
  'In Progress': 'In Progress',
  'Public Viewable': 'Public Viewable',
  'dm_draft': 'In Progress',
  'dm_published': 'Public Viewable',
};

export const DOC_STATUS_CODE = {
  'In Progress': '0',
  'Public Viewable': '1',
  'dm_draft': '0',
  'dm_published': '1',
};

const documentSelector = state => _.get(state, "document.data");
const loggedInUserSelector = state => _.get(state, "session.user.data");
const docStatusByProjectSelector = state => _.get(state, "document.documentStatusByProject.data", {});

const formValueSelector = state =>
  _.get(state, "form.editDocumentMetadata.values");
const initialFormValuesSelector = state =>
  _.get(state, "form.editDocumentMetadata.initial");
const projectIdSelector = state =>
  _.get(state, "projectDetails.data.projectDetails.closing_id");
const documentTypeSelector = state =>
  _.get(state, "document.documentTypes");
let editMetadata;

export default function* editDocMetadataWatcher() {
  yield takeLatest(actions.EDIT_METADATA, editDocMetadataWorker);
}

export function* editDocMetadataWorker(action) {
  yield put(actions.loading(true));
  const formValues = yield select(formValueSelector);
  const initalformValues = yield select(initialFormValuesSelector);
  const projectId = yield select(projectIdSelector);
  const oldStatus = initalformValues.doc_status;
  const docStatuses = yield select(documentTypeSelector);
  //formValues.ecm_attr_doc_date = `${formValues.ecm_attr_doc_date}`;

  if (formValues.ecm_attr_doc_date && !formValues.ecm_attr_doc_date.includes("T")) {
    formValues.ecm_attr_doc_date = formValues.ecm_attr_doc_date + "T13:00:00";
  }

  //formValues.ecm_attr_doc_date = setDate(`${formValues.ecm_attr_doc_date}`);
  formValues.r_version_label = setDocumentStatus(
    formValues.r_version_label,
    formValues.doc_status,
  );

  const selectIndex = _.findIndex(docStatuses, { type_name: formValues.doc_type });
  if (selectIndex > -1){
      formValues.doc_type_name = docStatuses[selectIndex].label_text;
      formValues.doc_type_desc = formValues.doc_type_name;
  } else {
    formValues.doc_type_name = '';
    formValues.doc_type_desc = '';
  }

  editMetadata = formValues;
  formValues.project_id = projectId.toString();
  formValues.old_status = oldStatus;
  console.log("formValues", formValues);
  try {
    // WAF NOTE (Aug 2026): the wire-level GraphQL field is `documentName`, not
    // `object_name` -- Walmart's Cloudflare WAF flags the literal string
    // "object_name" in POST bodies as a SQL-injection signature match, which
    // blocks external (non-VPN) users with a 444. We keep `object_name` on
    // `formValues`/`editMetadata` for local redux-form + local state usage
    // (see success() below) and only rename it in the payload actually sent
    // over the wire. See tasks/LESSONS.md for the full investigation history.
    const { object_name, ...graphqlVariables } = formValues;
    graphqlVariables.documentName = object_name;
    const response = yield call(editDocumentMetadata, graphqlVariables);
    yield call(success, response);
  } catch (error) {
    console.log("Error: ", error);
    yield call(failure, error);
  }
}

export function* success(response) {
  yield put(actions.loading(false));
  const data = _.get(response, "data.updateDocumentMetadata", []);
  const loggedInUserData = yield select(loggedInUserSelector);

  if (data.Success) {
    let documents = [];
    documents = yield select(documentSelector);
    let docIndex = _.findKey(documents, {
      documentum_doc_id: editMetadata.i_chronicle_id,
    });
   
    documents[docIndex].closing_doc_name = editMetadata.object_name;
    documents[docIndex].last_change_ts = new Date().toISOString();
    if (loggedInUserData) {
      documents[docIndex].last_change_userid = loggedInUserData.loginId;
    }
    if (editMetadata.doc_status) {
      documents[docIndex].public_view_status =
        DOC_STATUS_DISPLAY[editMetadata.doc_status] || editMetadata.doc_status;
    }
    
    let documentEdited = documents[docIndex];

    if (docIndex > -1) {
      documents.splice(docIndex, 1);
    }
    documents.unshift(documentEdited);

    yield put(actions.setData(documents));

    // Update documentStatusByProject in Redux
    if (editMetadata.doc_status) {
      const docStatusByProject = yield select(docStatusByProjectSelector);
      const updatedDocStatus = {
        ...docStatusByProject,
        [editMetadata.i_chronicle_id]: DOC_STATUS_CODE[editMetadata.doc_status] || '0',
      };
      yield put(actions.setDocStatusByProj(updatedDocStatus));
    }

    yield put(actions.closeEditDocumentMetadataModal());
    yield put(actions.setMetaDataForProject({ ...editMetadata }));
    yield put(actions.fetchDocumentVersionsData(editMetadata.i_chronicle_id));
    yield put(
      openSnackbar({
        message: "Metadata updated!",
        showCloseIcon: true,
      }),
    );
    yield put(fetchProject(parseInt(documentEdited.closing_id)));

  } else {
    yield call(failure, data.responseMessage);
  }
}

export function* failure(error) {
  yield put(actions.loading(false));
  yield put(actions.error(error));
  const errorMessage = error || '';
  if (typeof errorMessage === 'string' && errorMessage.includes("E_IMMUTABLE_OBJECT")) {
    yield put(
      errorOpenModal({
        title: "Metadata Could Not Be Updated!",
        message: "The Document is Immutable",
      }),
    );
  }else if (typeof errorMessage === 'string' && errorMessage.includes("DOC_DUPLICATE")) {
    yield put(
      errorOpenModal({
        title: "Metadata Could Not Be Updated!",
        message: "Another document already has that name, type, and sub type for this store.  Please rename the document or change its type or sub type.",
      }),
    );
  }else {
    yield put(
      errorOpenModal({
        title: "Metadata Could Not Be Updated!",
        message: typeof errorMessage === 'string' && errorMessage.length > 0
          ? errorMessage
          : "An error occured while updating the document.",
      }),
    );
  }
  return error;
}
